import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	CORRESPONDENCE_REQUEST_CATEGORY_FEATURE_KEY,
	CorrespondenceRequestCategoryState,
	CorrespondenceRequestCategoryPartialState,
	correspondenceRequestCategoryAdapter
} from './request-category.reducer';

// Lookup the 'CorrespondenceRequestCategory' feature state managed by NgRx
export const getCorrespondenceRequestCategoryState = createFeatureSelector<
	CorrespondenceRequestCategoryPartialState,
	CorrespondenceRequestCategoryState
>(CORRESPONDENCE_REQUEST_CATEGORY_FEATURE_KEY);

const { selectAll, selectEntities } = correspondenceRequestCategoryAdapter.getSelectors();

export const getCorrespondenceRequestCategoryLoaded = createSelector(
	getCorrespondenceRequestCategoryState,
	(state: CorrespondenceRequestCategoryState) => state.loaded
);

export const getCorrespondenceRequestCategoryError = createSelector(
	getCorrespondenceRequestCategoryState,
	(state: CorrespondenceRequestCategoryState) => state.error
);

export const loadingCorrespondenceRequestCategory = createSelector(
	getCorrespondenceRequestCategoryState,
	(state: CorrespondenceRequestCategoryState) => state.loaded
);

export const getAllCorrespondenceRequestCategory = createSelector(
	getCorrespondenceRequestCategoryState,
	(state: CorrespondenceRequestCategoryState) => selectAll(state)
);

export const getCorrespondenceRequestCategoryEntities = createSelector(
	getCorrespondenceRequestCategoryState,
	(state: CorrespondenceRequestCategoryState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getCorrespondenceRequestCategoryState,
	(state: CorrespondenceRequestCategoryState) => state.selectedCorrespondenceRequestCategoryId
);

export const getSelected = createSelector(
	getCorrespondenceRequestCategoryEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
